<template>
  <div>
    <md-dialog
      :md-active.sync="showSidepanel"
      :md-backdrop="true"
      class="setting-user-info-dialog"
      :md-click-outside-to-close="false"
      @md-opened="clearPermit"
    >
      <div :class="checkBackdrop ? 'bg-backdrop' : ''"></div>
      <md-dialog-title>
        <div class="title-panel">{{ titlePanel }}</div>
        <md-menu md-size="big">
          <md-button
            class="md-icon-button more-vert"
            md-menu-trigger
            v-if="permission.acl['setting'].menus['users'].edit"
          >
            <md-icon>more_vert</md-icon>
          </md-button>
          <md-menu-content class="menu-vert">
            <md-menu-item @click="editUser()">
              <span>Edit</span>
            </md-menu-item>
          </md-menu-content>
        </md-menu>
      </md-dialog-title>

      <md-tabs>
        <md-tab id="tab-home" md-label="Basic Infomation">
          <div class="md-layout">
            <div class="md-layout-item md-medium-size-50 md-small-size-50">
              <md-field class="md-has-value">
                <label for="first-name">Username</label>
                <md-input
                  name="username"
                  id="username"
                  autocomplete="given-name"
                  v-model="user.username"
                  readonly
                />
              </md-field>
            </div>
            <div class="md-layout-item md-medium-size-50 md-small-size-50">
              <md-field class="md-has-value">
                <label for="email">Email</label>
                <md-input
                  type="email"
                  name="email"
                  id="email"
                  autocomplete="email"
                  v-model="user.email"
                  readonly
                />
              </md-field>
            </div>
          </div>
          <div class="md-layout">
            <div
              class="md-layout-item md-medium-size-50 md-small-size-50 -font-kanit"
            >
              <md-field class="md-has-value">
                <label for="first-name">First Name</label>
                <md-input
                  name="first-name"
                  id="first-name"
                  autocomplete="given-name"
                  v-model="user.firstname"
                  readonly
                />
              </md-field>
            </div>
            <div
              class="md-layout-item md-medium-size-50 md-small-size-50 -font-kanit"
            >
              <md-field class="md-has-value">
                <label for="last-name">Last Name</label>
                <md-input
                  name="last-name"
                  id="last-name"
                  autocomplete="family-name"
                  v-model="user.lastname"
                  readonly
                />
              </md-field>
            </div>
          </div>
          <div class="md-layout -lastrow">
            <div class="md-layout-item md-medium-size-50 md-small-size-50">
              <md-field class="md-has-value">
                <label for="last-name">User Group</label>
                <md-input
                  name="usergroup"
                  id="usergroup"
                  autocomplete="family-name"
                  v-model="user.user_group"
                  readonly
                />
              </md-field>
            </div>
            <div class="md-layout-item md-medium-size-50 md-small-size-50">
              <md-checkbox class="md-primary" v-model="status" disabled
                >Active</md-checkbox
              >
            </div>
          </div>
          <div class="md-layout -lastrow">
            <div class="md-layout-item md-medium-size-50 md-small-size-50">
              <md-field class="md-has-value">
                <label for="last-name">Role</label>
                <md-input
                  name="userrole"
                  id="userrole"
                  autocomplete="family-name"
                  v-model="user.role_type"
                  readonly
                />
              </md-field>
            </div>
            <div
              class="md-layout-item md-medium-size-50 md-small-size-50"
            ></div>
          </div>
        </md-tab>

        <md-tab id="tab-pages" md-label="Permission">
          <div class="div-cover-table">
            <table id="table-permission">
              <thead>
                <th>Module</th>
                <th>View</th>
                <th>Add</th>
                <th>Edit</th>
                <th>Delete</th>
                <th>Approve</th>
                <th>Export</th>
              </thead>
              <tbody>
                <template v-for="item in Modules">
                  <tr class="background-module">
                    <td class="module">{{ item.title }}</td>
                    <td width="100px;">
                      <md-checkbox
                        class="md-primary"
                        v-model="permit[getModuleName(item.url)].view"
                        disabled
                      ></md-checkbox>
                    </td>
                    <td width="100px;">
                      <md-checkbox
                        class="md-primary"
                        v-model="permit[getModuleName(item.url)].add"
                        disabled
                      ></md-checkbox>
                    </td>
                    <td width="100px;">
                      <md-checkbox
                        class="md-primary"
                        v-model="permit[getModuleName(item.url)].edit"
                        disabled
                      ></md-checkbox>
                    </td>
                    <td width="100px;">
                      <md-checkbox
                        class="md-primary"
                        v-model="permit[getModuleName(item.url)].delete"
                        disabled
                      ></md-checkbox>
                    </td>
                    <td width="100px;">
                      <md-checkbox
                        class="md-primary"
                        v-model="permit[getModuleName(item.url)].approve"
                        disabled
                      ></md-checkbox>
                    </td>
                    <td width="100px;"></td>
                  </tr>
                  <template v-for="subitem in item.sub">
                    <tr>
                      <td class="sub-item">{{ subitem.title }}</td>
                      <td width="100px;">
                        <md-checkbox
                          class="md-primary"
                          v-model="
                            permit[getModuleName(item.url)].menus[
                              getMenuName(subitem.url)
                            ].view
                          "
                          disabled
                        ></md-checkbox>
                      </td>
                      <td width="100px;">
                        <md-checkbox
                          class="md-primary"
                          v-model="
                            permit[getModuleName(item.url)].menus[
                              getMenuName(subitem.url)
                            ].add
                          "
                          disabled
                        ></md-checkbox>
                      </td>
                      <td width="100px;">
                        <md-checkbox
                          class="md-primary"
                          v-model="
                            permit[getModuleName(item.url)].menus[
                              getMenuName(subitem.url)
                            ].edit
                          "
                          disabled
                        ></md-checkbox>
                      </td>
                      <td width="100px;">
                        <md-checkbox
                          class="md-primary"
                          v-model="
                            permit[getModuleName(item.url)].menus[
                              getMenuName(subitem.url)
                            ].delete
                          "
                          disabled
                        ></md-checkbox>
                      </td>
                      <td width="100px;">
                        <md-checkbox
                          class="md-primary"
                          v-model="
                            permit[getModuleName(item.url)].menus[
                              getMenuName(subitem.url)
                            ].approve
                          "
                          disabled
                        ></md-checkbox>
                      </td>
                      <td width="100px;">
                        <md-checkbox
                          class="md-primary"
                          v-show="
                            subitem.title == 'Pricing List' ||
                              subitem.title == 'Book Price'
                          "
                          v-model="
                            permit[getModuleName(item.url)].menus[
                              getMenuName(subitem.url)
                            ].export
                          "
                          disabled
                        ></md-checkbox>
                      </td>
                    </tr>
                  </template>
                </template>
              </tbody>
            </table>
          </div>
        </md-tab>

        <md-tab id="tab-approve" md-label="Approval">
          <!-- <div class="-head">{{ user.firstname }} {{ user.lastname }}</div>
          <hr class="hr-head" style="margin: 0px 30px; opacity: 0.2;" />-->

          <div class="-body -font-kanit">
            <div
              class="-detail"
              v-show="defaultFirstname !== '' && defaultLastname !== ''"
            >
              <div class="-empty"></div>
              <div class="-data">
                {{ defaultFirstname }} {{ defaultLastname }}
              </div>
              <div style="margin-left: 25px;">
                <md-icon style="color: gray;" title="Role approve from my hr"
                  >person</md-icon
                >
              </div>
            </div>

            <div
              class="-detail"
              v-for="(item, index) in user.select"
              :key="index"
            >
              <div class="-empty"></div>
              <div class="-data">{{ item.firstname }} {{ item.lastname }}</div>
            </div>

            <!-- <div
              class="-detail"
              v-for="(item, index) in user.data_approve"
              :key="index"
            >
              <div class="-empty"></div>
              <div class="-data">{{ item.firstname }} {{ item.lastname }}</div>
            </div>-->
          </div>
        </md-tab>

        <md-tab id="tab-view-promotion" md-label="View Promotion">
          <div class="-font-kanit" style="margin: 10px 50px;">
            กำหนดสิทธิ์การมองเห็น Promotion By User Create
          </div>
          <div class="-body -font-kanit" id="promo">
            <div>
              <div
                class="-detail"
                v-for="(data, key) in user.default_under"
                :key="key"
              >
                <div class="-empty"></div>
                <div class="-data">
                  {{ data.firstname }} {{ data.lastname }}
                </div>
                <div style="margin-left: 25px;">
                  <md-icon style="color: gray;" title="Role from my hr"
                    >person</md-icon
                  >
                </div>
              </div>
            </div>

            <div>
              <div
                class="-detail"
                v-for="(item, index) in user.select_promo"
                :key="index"
              >
                <div class="-empty"></div>
                <div class="-data">
                  {{ item.firstname }} {{ item.lastname }}
                </div>
              </div>
            </div>
          </div>
        </md-tab>
      </md-tabs>

      <md-dialog-actions class="-action">
        <!-- <md-button class="-cancel" @click="showSidepanel = false">CLOSE</md-button> -->
        <md-button class="-cancel" @click="onClickClose()">CLOSE</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog-confirm
      :md-active.sync="showDialogCancel"
      :md-click-outside-to-close="false"
      md-content="Are you sure you want to close ?"
      md-confirm-text="OK"
      md-cancel-text="CANCEL"
      @md-cancel="onCancel"
      @md-confirm="onConfirm"
    />
  </div>
</template>

<script>
var _ = require("lodash");

import Vue from "vue";
import UserService from "@/services/user";
export default {
  name: "user-info-panel",
  props: {
    Info: {
      type: Object,
      default: []
    }
  },
  computed: {
    permission() {
      return this.$jwt.decode(localStorage.getItem("token"));
    }
  },
  data() {
    return {
      checkBackdrop: false,
      showDialogCancel: false,
      titlePanel: "User Infomation",
      showSidepanel: false,
      status: false,
      user: {},
      Modules: [],
      permit: {},
      showInfo: false,
      showPermission: true,
      dataApprove: {},
      defaultFirstname: "",
      defaultLastname: ""
    };
  },
  watch: {
    Info: function(value) {
      this.user = value;
      // console.log("this.user ==>", this.user);
      /* TAB APPROVAL */
      this.defaultFirstname = this.user.default.firstname
        ? this.user.default.firstname
        : "";
      this.defaultLastname = this.user.default.lastname
        ? this.user.default.lastname
        : "";

      if (this.user.status == "active") this.status = true;
      else this.status = false;

      // this.dataApprove = {
      //     role_by_hr : {
      //             {
      //             "code" : "361011",
      //             "firstname" : "กรรณกร",
      //             "lastname" : "คมนา"
      //         },{
      //             "code" : "361011",
      //             "firstname" : "กรรณกร",
      //             "lastname" : "คมนา"
      //         }
      //     }
      // }

      // this.getModule();

      // _.merge(this.permit ,this.Info.acl_module);

      // console.log('watch')
      // console.log(this.permit);

      // this.permit = this.Info.acl_module;

      // Vue.set(this.permit ,this.Info.acl_module);

      // console.log('permit watch', this.permit)
    }
  },
  created() {
    this.getModule();
  },
  methods: {
    onConfirm() {
      this.checkBackdrop = false;
      this.showSidepanel = false;
      this.showInfo = false;
      this.showPermission = true;
      this.showDialogCancel = false;
    },
    onCancel() {
      this.checkBackdrop = false;
    },
    onClickInfo() {
      this.showInfo = this.showInfo == false ? true : false;
      this.showPermission = this.showPermission == false ? true : false;
    },
    onClickPermission() {
      this.showPermission = this.showPermission == false ? true : false;
      this.showInfo = this.showInfo == false ? true : false;
    },
    onClickClose() {
      // this.showSidepanel = false;
      // this.showInfo = false;
      // this.showPermission = true;
      this.checkBackdrop = true;
      this.showDialogCancel = true;
    },
    editUser() {
      this.showSidepanel = false;
      this.$emit("onEdit", this.Info);
    },
    deleteUser() {
      this.showSidepanel = false;
      this.$emit("onDelete", this.Info._id);
    },
    getModuleName(url) {
      return url.split("/")[1];
    },
    getMenuName(url) {
      return url.split("/")[2]; //.replace("-", '_');
    },
    getModule() {
      // console.log('get module')
      UserService.getAllModule()
        .then(response => {
          response.forEach(module => {
            Vue.set(this.permit, this.getModuleName(module.url), {
              view: false,
              add: false,
              edit: false,
              delete: false,
              approve: false
            });
            var m = {};
            module.sub.forEach(menus => {
              Vue.set(m, this.getMenuName(menus.url), {
                view: false,
                add: false,
                edit: false,
                delete: false,
                approve: false
              });
            });
            Vue.set(this.permit[this.getModuleName(module.url)], "menus", m);

            // this.permit["overview"].menus["book-price"].edit = true;
            // this.permit["overview"].menus["book-price"].approve = true;
          });
          this.Modules = response;
          // this.permit = this.Modules;
          // this.Modules.forEach(el=>{
          //     // console.log(el);

          // })

          // console.log('Module', this.Modules)

          // console.log("get all module")
        })
        .catch(error => console.log(error));
    },
    setValue() {
      // this.permit = _.merge(this.permit, this.Info.acl_module);
      // console.log(this.permit);
      this.clearPermit();
    },
    clearPermit() {
      this.Modules.forEach(module => {
        Vue.set(this.permit, this.getModuleName(module.url), {
          view: false,
          add: false,
          edit: false,
          delete: false,
          approve: false
        });
        var m = {};
        module.sub.forEach(menus => {
          Vue.set(m, this.getMenuName(menus.url), {
            view: false,
            add: false,
            edit: false,
            delete: false,
            approve: false
          });
        });
        Vue.set(this.permit[this.getModuleName(module.url)], "menus", m);
      });

      if (this.Info.acl_module.overview.menus["book-price"] && this.Info.acl_module.overview.menus["book-price"].add) {
        this.Info.acl_module.overview.menus["book-price"].edit = true;
        this.Info.acl_module.overview.menus["book-price"].approve = true;
      } else if(this.Info.acl_module.overview.menus["book-price"]) {
        this.Info.acl_module.overview.menus["book-price"].edit = false;
        this.Info.acl_module.overview.menus["book-price"].approve = false;
      }
      _.merge(this.permit, this.Info.acl_module);
    }
  }
};
</script>

<style lang="scss">
.setting-user-info-dialog {
  width: 70%;
  height: 80%;
  z-index: 6 !important;
  transform: unset !important;
  top: 10% !important;
  left: 15% !important;

  .md-dialog-container {
    width: 100%;
  }

  .md-dialog-title {
    &.md-title {
      font-size: 18px;
      margin-bottom: 5px;
      padding: 24px 30px 0;
    }

    .title-panel {
      position: fixed;
    }

    .md-menu {
      width: 102%;
      text-align: right;

      .more-vert {
        height: 25px;
        width: 25px;
        min-width: 25px;
      }
    }
  }

  .-mainshow {
    cursor: pointer;
    background-color: #ececec !important;
  }

  .-content {
    margin: 12px 25px 3px 25px;
    border: 1px solid #ddd;
    background-color: #f5f5f5;

    .md-layout {
      padding-top: 10px;

      &.-head {
        padding: 15px 15px 12px 15px;
        font-size: 16px;
        font-weight: bold;
      }

      &.-lastrow {
        padding-bottom: 5px;
      }

      .md-layout-item {
        padding-right: 15px;
        padding-left: 15px;

        .md-checkbox {
          margin-top: 30px;
        }

        .md-has-value {
          margin-bottom: 10px;
        }
      }
    }

    #table-permission {
      border-collapse: collapse;
      width: 100%;

      th,
      td {
        padding: 5px 8px;
        text-align: left;

        &.-checkbox {
          padding-top: 7px;
          padding-bottom: 3px;
        }
      }

      tr:hover {
        background-color: #ececec;
      }

      .md-checkbox {
        margin: 0px !important;
      }

      .module {
        font-weight: bold;
      }

      .background-mobule {
        background-color: red;
      }

      .sub-item {
        padding-left: 30px;
      }
    }
  }

  .md-tabs {
    margin-top: 5px;

    .-font-kanit {
      font-size: 15px !important;
      font-family: kanit;
      font-weight: 300;
    }

    #tab-home {
      margin-top: 12px;
    }

    .md-button,
    .md-ripple {
      height: 35px;
    }

    .md-tabs-navigation {
      border-bottom: 1px solid rgba(128, 128, 128, 0.25);
    }

    .md-layout-item {
      padding-right: 15px;
      padding-left: 15px;

      .multiselect {
        margin-top: 12px;
      }

      .-password {
        .md-button {
          margin-top: 13px;
          height: 33px !important;
        }
      }

      .md-checkbox {
        margin-top: 25px;
      }
    }

    #tab-pages {
      .div-cover-table {
        height: calc(80vmin - 170px);
        overflow-y: auto;

        &::-webkit-scrollbar {
          height: 7px;
          width: 8px;
        }
      }

      #table-permission {
        border-collapse: collapse;
        width: 100%;

        th,
        td {
          padding: 5px 8px;
          text-align: left;
          // border-bottom: 1px solid #ddd;

          &.-checkbox {
            padding-top: 7px;
            padding-bottom: 3px;
          }
        }

        tr:hover {
          background-color: #f5f5f5;
        }

        .md-checkbox {
          margin: 0px !important;
        }

        .module {
          font-weight: bold;
        }

        .background-mobule {
          background-color: red;
        }

        .sub-item {
          padding-left: 30px;
        }
      }
    }
  }

  .-action {
    position: fixed;
    padding: 8px 20px 10px 24px;
    bottom: 0px;
    margin-right: auto;
    margin-left: auto;
    width: 100%;

    .md-button {
      margin-right: 0px !important;
    }

    .md-ripple {
      width: 100%;
      margin: 0;
    }

    .-cancel {
      color: #727272 !important;
      margin-right: 10px;
    }
  }

  .bg-backdrop {
    background: rgba(0, 0, 0, 0.6);
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 7;
    top: 0;
    left: 0;
  }
}
</style>
